export enum SeverityEnum{
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Danger = 'danger',
}
